// Top-level navigation items shared between desktop nav + mobile drawer.
// `type: "anchor"` items smooth-scroll to a section id on the landing page.
// `type: "route"` items navigate via React Router.
export const NAV_ITEMS = [
  { label: "How It Works", to: "/#how-it-works", type: "anchor", anchor: "how-it-works" },
  { label: "Optimization Programs", to: "/#programs", type: "anchor", anchor: "programs" },
  { label: "Medical Care", to: "/medical-care", type: "route" },
  { label: "Technology", to: "/technology", type: "route" },
  { label: "About", to: "/founder-story", type: "route" },
  { label: "Resources", to: "/evidence", type: "route" },
];
